export function makeMatrix(reelsAmount: number, rowsAmount: number, placeholder = -1): number[][] {
    const matrix = [];

    for (let i = 0; i < reelsAmount; i++) {
        const row = [];

        for (let j = 0; j < rowsAmount; j++) {
            row[j] = placeholder;
        }

        matrix[i] = row;
    }

    return matrix;
}

export function objectHashMapToMap<K, V>(hasMap: any): Map<K, V> {
    const map = new Map<K, V>();

    for (const key in hasMap) {
        if (hasMap.hasOwnProperty(key)) {
            map.set(key as any, hasMap[key]);
        }
    }

    return map;
}

export function forEachReelsMatrixBySize(reelsMatrixSize: number[], callback: (reelIndex: number, rowIndex: number) => void): void {
    for (let reelIndex = 0; reelIndex < reelsMatrixSize.length; reelIndex++) {
        const rowsAmount = reelsMatrixSize[reelIndex];

        for (let rowIndex = 0; rowIndex < rowsAmount; rowIndex++) {
            callback(reelIndex, rowIndex);
        }
    }
}

export function makeReelsMatrix(reelsMatrixSize: number[], placeholder = -1): number[][] {
    const matrix: number[][] = [];

    forEachReelsMatrixBySize(reelsMatrixSize, (reelIndex, rowIndex) => {
        if (!matrix[reelIndex]) {
            matrix[reelIndex] = [];
        }

        matrix[reelIndex][rowIndex] = placeholder;
    });

    return matrix;
}

/**
 * Select file(s).
 * @param {String} contentType The content type of files you wish to select. For instance "image/*" to select all kinds of images.
 * @param {Boolean} multiple Indicates if the user can select multiples file.
 * @returns {Promise<File|File[]>} A promise of a file or array of files in case the multiple parameter is true.
 */
export function loadFileDialog(contentType: string, multiple = false): Promise<File[]> {
    return new Promise(resolve => {
        const input = document.createElement('input');

        input.type = 'file';
        input.multiple = multiple;
        input.accept = contentType;

        input.onchange = _ => {
            const files = input.files ? Array.from(input.files) : [];

            resolve(files);
        };

        input.click();
    });
}

export function saveObjectToFile(object: {}, fileName: string): void {
    const a = document.createElement('a');
    const file = new Blob([JSON.stringify(object, null, 4)], {type: 'text/plain'});

    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
}

export function readFilesAsArrayBuffer(files: File[]): Promise<Map<string, ArrayBuffer>> {
    const promises = files.map(file => {
        return new Promise<[string, ArrayBuffer]>(resolve => {
            const reader: FileReader = new FileReader();
            const name = file.name.split('.')[0];

            reader.onload = (e) => {
                const source: ArrayBuffer = ((e.target as FileReader).result as ArrayBuffer);

                resolve([name, source]);
            };
            reader.readAsArrayBuffer(file);
        });
    });

    return Promise.all<[string, ArrayBuffer]>(promises).then((sources) => new Map(sources));
}